import type { Variants } from 'framer-motion';

// 统一动画配置
export const ANIMATION_CONFIG = {
    duration: {
        fast: 0.2,
        normal: 0.3,
        slow: 0.5,
    },
    ease: {
        // 类似于 CSS 的 ease-out
        out: [0.25, 0.46, 0.45, 0.94] as const,
        // 类似于 CSS 的 ease-in-out
        inOut: [0.42, 0, 0.58, 1] as const,
        // 弹性效果
        spring: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
        },
    },
};

// 常用变体 (Variants)
export const FADE_IN: Variants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { duration: ANIMATION_CONFIG.duration.normal }
    },
    exit: {
        opacity: 0,
        transition: { duration: ANIMATION_CONFIG.duration.fast }
    },
};

export const SLIDE_IN_RIGHT: Variants = {
    hidden: { x: '100%', opacity: 0 },
    visible: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'spring',
            damping: 25,
            stiffness: 200
        }
    },
    exit: {
        x: '100%',
        opacity: 0,
        transition: { duration: ANIMATION_CONFIG.duration.fast }
    },
};

export const SCALE_IN: Variants = {
    hidden: { scale: 0.9, opacity: 0 },
    visible: {
        scale: 1,
        opacity: 1,
        transition: { duration: ANIMATION_CONFIG.duration.fast }
    },
    exit: {
        scale: 0.9,
        opacity: 0,
        transition: { duration: ANIMATION_CONFIG.duration.fast }
    },
};

// 从底部滑入（用于 DiscountPanel）
export const SLIDE_IN_BOTTOM: Variants = {
    hidden: { y: '100%', opacity: 0 },
    visible: {
        y: '0%',
        opacity: 1,
        transition: {
            type: 'spring' as const,
            damping: 25,
            stiffness: 200
        }
    },
    exit: {
        y: '100%',
        opacity: 0,
        transition: { duration: ANIMATION_CONFIG.duration.normal }
    },
};

// CartItem 退场动画（渐隐 + 高度收缩）
export const ITEM_EXIT: Variants = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: {
        opacity: 0,
        height: 0,
        marginBottom: 0,
        marginTop: 0,
        paddingTop: 0,
        paddingBottom: 0,
        overflow: 'hidden',
        transition: {
            opacity: { duration: 0.2, ease: ANIMATION_CONFIG.ease.out },
            height: { duration: 0.3, delay: 0.1, ease: ANIMATION_CONFIG.ease.inOut },
            marginBottom: { duration: 0.3, delay: 0.1, ease: ANIMATION_CONFIG.ease.inOut },
            marginTop: { duration: 0.3, delay: 0.1, ease: ANIMATION_CONFIG.ease.inOut },
            paddingTop: { duration: 0.3, delay: 0.1, ease: ANIMATION_CONFIG.ease.inOut },
            paddingBottom: { duration: 0.3, delay: 0.1, ease: ANIMATION_CONFIG.ease.inOut }
        }
    },
};

export const DRAWER_GESTURE_CONFIG = {
    dragConstraints: { left: 0, right: 0 },
    dragElastic: { left: 0, right: 0.5 },
    dragSnapToOrigin: true,
};

export const CART_DRAWER_TRANSITION = {
    type: 'spring',
    damping: 25,
    stiffness: 200
} as const;

export const CART_INFO_PANEL_MOTION = {
    initial: { opacity: 0, scale: 0.98, y: 4 },
    animate: { opacity: 1, scale: 1, y: 0 },
    exit: { opacity: 0, scale: 1.02, y: -4 },
    transition: {
        type: 'spring',
        stiffness: 400,
        damping: 35
    }
} as const;
